import { useState, useEffect } from 'react';
import Seo from '@/components/shared/Seo';
import Loading from '@/components/shared/Loading';
import Image from 'next/image';
import { ImageWithFallback } from '../shared/NextImageFallback';
const endings = [', most likely', ', probably', ', definitely', ', for sure', ', fr fr', ', allegedly', ', supposedly'];
export const geniusData = [{
  quote: 'Bulls... bears...it’s all relative, man',
  quoteBy: 'Einstein' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava1.png'
}, {
  quote: 'Crypto is more important than Gravity',
  quoteBy: 'Newton' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava2.png'
}, {
  quote: 'Dog coins > fundamental physics',
  quoteBy: 'Tesla' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava4.png'
}, {
  quote: 'The  trenches are f***king brutal ',
  quoteBy: 'Sun Tzu' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava5.png'
}, {
  quote: 'PVP Environment...best be enlightened son',
  quoteBy: 'Plato' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava3.png'
}, {
  quote: 'E = MC² is cool, but have you seen these gains?',
  quoteBy: 'Einstein' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava1.png'
}, {
  quote: 'The half-life of these shitcoins is remarkably brief',
  quoteBy: 'Marie Curie' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava12.png'
}, {
  quote: 'For every pump, there is an equal and opposite dump',
  quoteBy: 'Newton' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava2.png'
}, {
  quote: 'I refuse to move from this position until my take profit hits',
  quoteBy: 'Rosa Parks' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava36.png'
}, {
  quote: 'The art of trading is fought with psychological warfare',
  quoteBy: 'Sun Tzu' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava5.png'
}, {
  quote: 'I heard voices telling me to buy the dip',
  quoteBy: 'Joan of Arc' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava28.png'
}, {
  quote: "I'm feeling good about this bull market",
  quoteBy: 'Nina Simone' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava24.png'
}, {
  quote: "To the moon? I've flown higher",
  quoteBy: 'Amelia Earhart' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava26.png'
}, {
  quote: 'God is dead, but crypto is eternal',
  quoteBy: 'Nietzsche' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava7.png'
}, {
  quote: 'One is not born, but becomes a degen',
  quoteBy: 'Simone de Beauvoir' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava23.png'
}, {
  quote: 'And still my portfolio rises',
  quoteBy: 'Maya Angelou' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava29.png'
}, {
  quote: 'It is a truth universally acknowledged that a trader must be in want of gains',
  quoteBy: 'Jane Austen' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava30.png'
}, {
  quote: 'HODL and be strong',
  quoteBy: 'Hemingway' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava13.png'
}, {
  quote: 'Because I could not stop for FUD, it kindly stopped for me',
  quoteBy: 'Emily Dickinson' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava33.png'
}, {
  quote: "I have created a monster... it's called my portfolio",
  quoteBy: 'Mary Shelley' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava35.png'
}, {
  quote: 'Natural selection will sort out the weak hands',
  quoteBy: 'Darwin' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava15.png'
}, {
  quote: 'The problem of the 21st century is the problem of the paper hands',
  quoteBy: 'W.E.B. Du Bois' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava32.png'
}, {
  quote: 'I came, I saw, I aped in',
  quoteBy: 'Alexander the Great' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava34.png'
}, {
  quote: 'I cannot tell a lie... these gains are unreal',
  quoteBy: 'George Washington' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava38.png'
}, {
  quote: 'Not all who retreat from the market are lost',
  quoteBy: 'Napoleon' + endings[Math.floor(Math.random() * endings.length)],
  image: 'ava39.png'
}];
export default function GeniusLoader({
  customText
}: {
  customText?: string;
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % geniusData.length);
        setFade(true);
      }, 1000);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  const {
    quote,
    quoteBy,
    image
  } = geniusData[currentIndex];
  return <div data-sentry-component="GeniusLoader" data-sentry-source-file="GeniusLoader.tsx">
      <div className='w-full min-h-screen p-2 flex flex-col justify-center items-center relative onboard-mobile'>
        <div className='flex-grow w-full onboard-box my-2 rounded-md'>
          <div className='z-10 flex flex-col inner-onboard ta-c'>
            <div className='flex flex-col w-full px-2'>
              <div className='flex flex-col items-center justify-center text-genius-cream'>
                <ImageWithFallback height={87} width={85} src={image} alt={quoteBy} className={`mt-20 transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`} data-sentry-element="ImageWithFallback" data-sentry-source-file="GeniusLoader.tsx" />
                <div className='mw-[288px] px-4'>
                  <p className={`leading-10 mt-6 text-[24px] text-genius-gradient font-normal transition-opacity duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}>
                    {quote}
                  </p>
                  <p className={`mt-6 text-sm text-genius-gradient-dark transition-opacity font-semibold duration-500 ${fade ? 'opacity-100' : 'opacity-0'}`}>
                    {quoteBy}
                  </p>
                </div>
                <div className={`my-10`}>
                  <Loading data-sentry-element="Loading" data-sentry-source-file="GeniusLoader.tsx" />
                </div>
                <div className='w-[240px] mt-2'>
                  <p className={`text-genius-cream/50 text-xs w-full ta-c`}>
                    {customText ? customText : ' Setting up your account. This’ll take a second. Be patient. Good things come to those who wait.'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}